<template>
  <div class="">
    <Header />
    <router-view />
    <Foot />
    <ShowAfter v-if="showAfter.show" :title="showAfter.title" :id="showAfter.id" />
    <!-- 转账钱包：进游戏前先转入额度（与移动端一致） -->
    <div class="gtMask" v-if="gtShow" @click.self="gtClose">
      <div class="gtDialog">
        <div class="gtHead">转入游戏额度<i class="gtX" @click="gtClose">×</i></div>
        <div class="gtBody">
          <div class="gtRow"><span>中心账户</span><b>￥{{ Number($store.state.userInfo.balance || 0).toFixed(2) }}</b></div>
          <div class="gtRow"><span>游戏账户（{{ gtName }}）</span><b>￥{{ Number(gtGameBalance).toFixed(2) }}</b></div>
          <div class="gtField"><input type="number" v-model="gtAmount" placeholder="请输入转入金额" /></div>
          <div class="gtChips">
            <span @click="gtQuick(100)">100</span>
            <span @click="gtQuick(500)">500</span>
            <span @click="gtQuick(1000)">1000</span>
            <span @click="gtQuick('all')">全部</span>
          </div>
          <div class="gtTip" v-if="Number($store.state.userInfo.balance || 0) < 1 && gtGameBalance < 1">中心账户暂无余额，请先充值后再进入游戏</div>
          <div class="gtBtns">
            <button class="gtBtn ghost" @click="gtClose">取消</button>
            <button class="gtBtn direct" v-if="gtGameBalance >= 1" @click="gtEnterDirect">直接进入</button>
            <button class="gtBtn primary" :disabled="gtLoading || Number($store.state.userInfo.balance || 0) < 1" @click="gtConfirm">{{ gtLoading ? '转入中...' : '转入并进入' }}</button>
          </div>
          <div class="gtRecharge" v-if="Number($store.state.userInfo.balance || 0) < 1 && gtGameBalance < 1" @click="gtGoRecharge">去充值 ›</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './libs/Header';
import Foot from './libs/Foot';
import ShowAfter from './assembly/ShowAfter';

export default {
  name: 'Main',
  data() {
    return {
      daoTime: null,
      showAfter: { show: false, title: '您还未登陆，请前往登录！' },
      jumpUrl: null,
      // 转账钱包：进游戏前的「转入额度」弹窗（与移动端一致）
      gtShow: false,
      gtName: '',
      gtType: '',
      gtCode: '',
      gtGameBalance: 0,
      gtAmount: '',
      gtLoading: false,
    };
  },
  components: {
    Header,
    Foot,
    ShowAfter,
  },
  created() {
    let that = this;

    if (localStorage.getItem('token')) {
      that.openDaoTime();
      that.getUserInfo();
    }
  
  },
  updated() {},
  mounted() {},
  methods: {
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.showTost(res.message);
        }
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
        }
      });
    },
    getApp() {
      let that = this;
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          // "ios_download_qrcode": "http://mb2.tg-demo.cc:86/uploads/images/e13177382b3e958789c877f71b034ca9.jpg",
          // "ios_download_url": "http://mb2.tg-demo.cc:86/",
          // "h5_url": "http://mb2m.tg-demo.cc"
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },
    showAfterHide() {
      let that = this;
      that.showAfter.show = false;
    },
    showAfterOk() {
      let that = this;
      this.$router.push({ path: '/login' });
    },
    openShow() {
      let that = this;
      that.showAfter.show = true;
    },
    // 打开游戏：强制转账模式——先弹「转入额度」弹窗，转入成功或已有额度才进游戏（与移动端一致）
    openGamePage(name, type, code) {
      let that = this;
      let token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
      if (!token) {
        that.openShow();
        return;
      }
      that.gtName = name;
      that.gtType = type;
      that.gtCode = code;
      that.gtAmount = '';
      that.gtGameBalance = 0;
      that.gtLoading = false;
      that.gtShow = true;
      that.getBalance();
      that.$apiFun
        .post('/api/userapimoney/' + name, {})
        .then(res => {
          if (res.code == 200 && res.data) {
            that.gtGameBalance = Number(res.data.balance) || 0;
          }
        })
        .catch(() => {});
    },
    gtQuick(v) {
      let plat = Math.floor(Number(this.$store.state.userInfo.balance) || 0);
      this.gtAmount = v === 'all' ? String(plat) : String(v);
    },
    gtClose() {
      this.gtShow = false;
    },
    gtGoRecharge() {
      this.gtShow = false;
      this.$router.push({ path: '/mine/deposit' });
    },
    gtConfirm() {
      let that = this;
      let plat = Number(that.$store.state.userInfo.balance) || 0;
      let amount = parseInt(that.gtAmount, 10);
      if (!amount || amount < 1) {
        that.showTost('请输入转入金额');
        return;
      }
      if (amount > plat) {
        that.showTost('转入金额不能大于中心账户余额');
        return;
      }
      that.gtLoading = true;
      that.$apiFun
        .post('/api/transfer', { amount: amount, sourcetype: 'userbalance', targettype: that.gtName })
        .then(res => {
          that.gtLoading = false;
          if (res.code == 200) {
            that.getBalance();
            that.gtShow = false;
            that.launchGame();
          } else {
            that.showTost(res.message || '转入失败');
          }
        })
        .catch(() => {
          that.gtLoading = false;
          that.showTost('转入失败，请重试');
        });
    },
    gtEnterDirect() {
      if (this.gtGameBalance < 1) {
        this.showTost('游戏账户暂无额度，请先转入');
        return;
      }
      this.gtShow = false;
      this.launchGame();
    },
    launchGame() {
      let that = this;
      let type = that.gtType || 0;
      that.showTost('正在前往打开游戏页面');
      that.$apiFun.post('/api/getGameUrl', { plat_name: that.gtName, game_type: type, game_code: that.gtCode, is_mobile_url: 0 }).then(res => {
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.jumpUrl = res.data.url;
        }
      });
    },
    openDaoTime() {
      let that = this;
      that.daoTime = setInterval(() => {
        that.getBalance();
      }, 2300);
    },
    close() {
      let that = this;
      if (that.daoTime) {
        clearInterval(that.daoTime);
      }
      that.daoTime = null;
    },
    getBalance() {
      let that = this;
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          if (res.code == 401) {
            that.showTost('登陆过期！');
            localStorage.clear();
            sessionStorage.clear();
            that.$store.commit('changUserInfo');
            that.$store.commit('changToken');
            that.close();
            that.$router.push({ path: '/login' });
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun
        .post('/api/refreshusermoney', {})
        .then(res => {
          if (res.code == 200) {
            localStorage.setItem('userInfo', JSON.stringify(res.data));
            that.$store.commit('changUserInfo');
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },

    openKefu() {
      let that = this;
      that.showTost('正在链接人工客服');
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.jumpUrl = res.data.url;
        }
      });
    },
    showTost(title) {
      $('body').append(`
            <div class='ant-message' style='top: 400px;'><span><div class='ant-message-notice'><div class='ant-message-notice-content'>
            <div class='ant-message-custom-content ant-message-info'><span role='img' aria-label='info-circle' class='anticon anticon-info-circle'>
            <svg viewBox='64 64 896 896' focusable='false' data-icon='info-circle' width='1em' height='1em' fill='currentColor' aria-hidden='true'>
            <path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z'></path></svg></span><span>
            ${title}
            </span></div></div></div></span>
            </div>`);
      setTimeout('$(".ant-message").detach()', 2000);
    },
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
  watch: {
    // 新窗口打开页面，解决浏览器拦截问题
    jumpUrl() {
      if (this.jumpUrl) {
        window.open(this.jumpUrl, '_blank');
      }
      this.jumpUrl = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.gtMask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gtDialog {
  width: 420px;
  max-width: 92vw;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
}
.gtHead {
  position: relative;
  height: 54px;
  line-height: 54px;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(90deg, #e7a977, #c9823f);
}
.gtX {
  position: absolute;
  right: 16px;
  top: 0;
  font-size: 24px;
  font-style: normal;
  cursor: pointer;
  opacity: 0.9;
}
.gtBody {
  padding: 20px 22px 24px;
}
.gtRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  color: #6b5b52;
  padding: 10px 0;
  border-bottom: 1px dashed #eee;
}
.gtRow b {
  color: #c9823f;
  font-size: 17px;
}
.gtField {
  margin: 16px 0 10px;
}
.gtField input {
  width: 100%;
  height: 46px;
  border: 1px solid #e3d6cc;
  border-radius: 10px;
  padding: 0 14px;
  font-size: 16px;
  box-sizing: border-box;
  outline: none;
}
.gtField input:focus {
  border-color: #c9823f;
}
.gtChips {
  display: flex;
  gap: 10px;
}
.gtChips span {
  flex: 1;
  text-align: center;
  height: 34px;
  line-height: 34px;
  border: 1px solid #e3d6cc;
  border-radius: 8px;
  font-size: 14px;
  color: #8a7a72;
  cursor: pointer;
}
.gtChips span:hover {
  border-color: #c9823f;
  color: #c9823f;
}
.gtTip {
  margin-top: 14px;
  color: #e02020;
  font-size: 13px;
  text-align: center;
}
.gtBtns {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}
.gtBtn {
  flex: 1;
  height: 46px;
  border: 0;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
.gtBtn.ghost {
  background: #f4f0ec;
  color: #8a7a72;
}
.gtBtn.direct {
  background: #fff4ec;
  color: #c9823f;
  border: 1px solid #e7a977;
}
.gtBtn.primary {
  background: linear-gradient(90deg, #e7a977, #c9823f);
  color: #fff;
}
.gtBtn.primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.gtRecharge {
  margin-top: 14px;
  text-align: center;
  color: #c9823f;
  font-size: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue